import toast from "react-hot-toast";
import * as api from "../Api";

export const approvedIndividualInvestments = () => async (dispatch) => {
  let fetchingId;
  try {
    const { data } = await api.approvedIndividualInvestments();
    dispatch({ type: "GET_APPROVED_INDIVIDUAL", payload: data });
    toast.remove(fetchingId);
  } catch (error) {
    toast.remove(fetchingId);
    toast.error(error.message);
  }
};
